module.exports = __webpack_public_path__ + "src/assets/img/s-sensors_w.a8b29c6b.svg";